import NoAdsIcon from "@mui/icons-material/Block";
import ChartIcon from "@mui/icons-material/BarChart";
import ListIcon from "@mui/icons-material/PlaylistAddCheck";
import BoltIcon from "@mui/icons-material/Bolt";
import DownloadIcon from "@mui/icons-material/Download";

// Der edle, dunkle Premium-Button mit langsam gold funkelndem Text
export const premiumButtonSx = {
    padding: { xs: '12px 24px', sm: '14px 28px' },
    fontSize: { sm: '1rem' },
    fontWeight: 700,
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #111827 0%, #1f2937 100%)',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    textTransform: 'none',
    transition: 'all 0.4s ease-in-out',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',

    '& .MuiTypography-root, &': {
        background: 'linear-gradient(90deg, #bf953f, #fffdd0, #b38728, #fffdd0, #bf953f)',
        backgroundSize: '400% 100%',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: 'goldShine 20s linear infinite',
    },

    '@keyframes goldShine': {
        '0%': { backgroundPosition: '0% 50%' },
        '100%': { backgroundPosition: '400% 50%' },
    },

    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 20px rgba(212, 175, 55, 0.15)',
        borderColor: 'rgba(212, 175, 55, 0.6)',
        background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
    }
};

// Die Icons erstrahlen nun passend in sanften Goldtönen
export const benefits = [
    { icon: <NoAdsIcon />, color: '#dfb76c', bg: 'rgba(212, 175, 55, 0.08)', title: 'Keine Werbung', desc: 'Trainiere ungestört – komplett werbefrei auf allen Geräten.' },
    { icon: <ChartIcon />, color: '#dfb76c', bg: 'rgba(212, 175, 55, 0.08)', title: 'Erweiterte Funktionen', desc: 'Exklusiver Zugang zum Gewichtstracker, 1RM Rechner und mehr.' },
    { icon: <ListIcon />, color: '#dfb76c', bg: 'rgba(212, 175, 55, 0.08)', title: 'Unbegrenzte Trainingspläne', desc: 'Erstelle so viele eigene Pläne und Übungen wie du möchtest.' },
    { icon: <DownloadIcon />, color: '#dfb76c', bg: 'rgba(212, 175, 55, 0.08)', title: 'Daten exportieren', desc: 'Exportiere deine Daten als PDF oder CSV.' },
    { icon: <BoltIcon />, color: '#dfb76c', bg: 'rgba(212, 175, 55, 0.08)', title: 'App-Vorabzug', desc: 'Vorabzugang zur kommenden fertigen App.' },
];

export const plans = [
    { label: 'Monatlich', price: '1,99', sub: '€/mo', desc: 'Jederzeit kündbar', featured: false },
    { label: 'Jährlich', price: '0,99', sub: '€/mo', desc: '11,88 € pro Jahr', featured: true },
];
